import { Coordinate } from "ol/coordinate"
import { RFeature, RFeatureUIEvent, RStyle } from "rlayers"
import { Point, Circle } from "ol/geom"
import PointIcon from "@/assets/map-point.svg"
import { useCallback } from "react"
import { Feature } from "ol"

export type OSMPointerDragEndEvent = {
	coords: Coordinate
}

type PointEvent = RFeatureUIEvent<Feature<Point>>

interface OSMPointerProps {
	coords: Coordinate
	onDragEnd: (event: OSMPointerDragEndEvent) => void
}

export function OSMPointer({ coords, onDragEnd }: OSMPointerProps) {
	return (
		<RFeature<Point>
			geometry={new Point(coords)}
			onPointerDrag={useCallback((e: PointEvent) => {
				const coords = e.map.getCoordinateFromPixel(e.pixel)
				e.target.setGeometry(new Point(coords))
				return false
			}, [])}
			onPointerDragEnd={useCallback(
				(e: PointEvent) => {
					const coords = e.map.getCoordinateFromPixel(e.pixel)
					onDragEnd({ coords })
				},
				[onDragEnd]
			)}
			onPointerEnter={useCallback(
				(e: PointEvent) =>
					(e.map.getTargetElement().style.cursor = "move") && undefined,
				[]
			)}
			onPointerLeave={useCallback(
				(e: PointEvent) =>
					(e.map.getTargetElement().style.cursor = "initial") && undefined,
				[]
			)}
		>
			<RStyle.RStyle>
				<RStyle.RIcon src={PointIcon} />
			</RStyle.RStyle>
		</RFeature>
	)
}
